module.exports = __webpack_public_path__ + "static/media/lb.4946e22f.svg";